
// Brad Trebilcock

// ThumbPageItemView.js

import $            from 'jquery';
import { View }     from 'backbone';
import template     from 'designer/thumb-page.ejs';
import eventBus from 'EventBus';
import constants from 'Constants';
import pageCollection from 'PageCollection';
import listService      from 'ListService';
import objectUtil from 'util/ObjectUtil.js';
import thumbPageListUtil from 'util/ThumbPageListUtil.js';
import util from 'util/Util';

const SILENT = constants.MODEL_SILENT;

//=========================================================
// This is a view on a single thumbnail page item
//=========================================================
class ThumbPageItemView extends View {


    initialize( opts ) {
        this.options = opts || {};

        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        
        this.events = {
        };
        
        this.collection = pageCollection;

        this._handleRename = ( (id, newPageName) => {
            // Rename only if id is that of this view's page
            if (id === this.model.get('id')){
                this.model.set( {'pageTitle': newPageName, 'name': newPageName}, SILENT);
                this._setDisplayPageTitle();
            }
        });

        this._handleObjectRename = ( (id, newObjectName) => {
            //Get the object from the array 
            let objArray = this.model.get('objects');
            const objIndex = objArray.findIndex(obj => obj.id === id);
             
           //Update model's property
            if (objIndex !==  -1){
                objArray[objIndex].name = newObjectName;
                this.model.set('objects', objArray, SILENT)
                this._setObjectName(id, newObjectName);
                let filteredPage  = this.collection.filter(function(e) {
                    return e.get('objects').some(function(a) {
                      return a.id === id
                    })
                  });
                filteredPage[0].set('objects', objArray, SILENT);
            }
        });

        // Make sure that these events are called just one time on each change
        if (!util.hasEventListener(eventBus._events, constants.EV_RENAME_PAGE)) {
            eventBus.on(constants.EV_RENAME_PAGE, this._handleRename);
        }
        if (!util.hasEventListener(eventBus._events, constants.EV_RENAME_OBJECT_PAGE)) {
            eventBus.on(constants.EV_RENAME_OBJECT_PAGE, this._handleObjectRename);
        }

        return this;
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();

        // Remove only THIS view's EV_RENAME_PAGE listener, leaving any other view's own listeners intact
        eventBus.off(constants.EV_RENAME_PAGE, this._handleRename);
        eventBus.off(constants.EV_RENAME_OBJECT_PAGE, this._handleObjectRename);

        super.remove();
    }

    _setDisplayPageTitle() {
        const
            newPageName = this.model.get('pageTitle'),
            seek = `h4.tn-target[data-page=${this.model.get('id')}]`;
        $(seek).attr('title', newPageName);
        $(`${seek} a`).text(newPageName);
    }

    _setObjectName(id, objectName){
        const seek = `li[data-id=${id}]`;
        $(`${seek} a`).text(objectName);
    }

    loadPageItemObjects(){
        const pageId = this.model.get('id'),
            page = listService.getPage(pageId),
            pageFactoryKey = page.model.get('factoryKey');
            
        thumbPageListUtil.updatePageList(pageId, pageFactoryKey);

    }

    //PF-6111 Used when an user deleted a page and undid the action, the page should be placed in its original place
    checkPageCorrectIndex(){

        const div = $(`#tn-pg-${this.model.id}`);
        const index = div.index();
        const container = $("#thumb-pages").find(".pageContainer");

        const swapPages = (parent, targetIndex, pageIndex) => { 
            
            const target = parent.get(targetIndex);
            const page = $(parent.get(pageIndex));
            page.insertBefore(target);
        }

        if(index !== this.model.currentIndex){
            swapPages(container, this.model.currentIndex, index);
        }
    }
    
    render() {
        if (this.template) {
            this.$el.append(this.template(this.model.toJSON()));
        }

        if(this.options.undo){
            this.checkPageCorrectIndex();
        }
        
        if (this.model.get('id') === listService.currentPageId || this.model.get("behaviorsOnly")){ //PF-5906 - Performance issues in IE, only the current page will be loaded, the rest will be loaded on demand
            this.loadPageItemObjects();
            this.delegateEvents();
        }
        return this;
    }

}

export default ThumbPageItemView;
